// extracted by mini-css-extract-plugin
export default {"result":"result_result__XqVRN","icon":"result_icon__URbx3","title":"result_title__yQn7B","subtitle":"result_subtitle__lR-11"};